import { render } from "./FAQItem.vue?vue&type=template&id=6326f76e&scoped=true"
import script from "./FAQItem.vue?vue&type=script&lang=js"
export * from "./FAQItem.vue?vue&type=script&lang=js"

import "./FAQItem.vue?vue&type=style&index=0&id=6326f76e&lang=scss&scoped=true"

import exportComponent from "/home/avangard/git/toode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6326f76e"]])

export default __exports__